import "./resource";

class UploadService {
    public static $inject: string[] = ["uploadResource"];

    private uploadResource;

    constructor(uploadResource) {
        this.uploadResource = uploadResource;
    }

    public uploadFile(file, content) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("content", JSON.stringify(content));

        const headers = {
            "x-media-type": content.type,
            "Content-Type": undefined
        };

        return this.uploadResource(headers, formData).create({}, formData).$promise;
    }
}

angular
    .module("thor.core.upload.service", [
        "thor.core.upload.resource"
    ])
    .service("uploadService", UploadService);
